<template>
    <div class="py-5 text-center">
        <div class="col-3 col-md-1 mx-auto mb-3">
            <a v-if="!showLogo || showLogo === 'true'" :href="siteUrl">
                <img class="d-block mx-auto w-100" :src="logo" alt="Logo">
            </a>
        </div>
        <h2 class="mb-1">{{ $t('iscrizione_online') }}</h2>
        <p class="lead mb-0">
            <span v-html="title"></span>
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            }
        },
        computed: {
            logo() {
                return this.$store.getters['settings/logo']
            },
            siteUrl() {
                return this.$store.getters['settings/site_url']
            },
            showLogo() {
                return this.$store.getters['settings/show_logo']
            }
        }
    }
</script>
